export default __webpack_public_path__ + "static/media/logo2.5e996453.png";